enum PillStyle {
  DEFAULT = 'default',
  /**
   * @deprecated chip style will be moved to tab component in future version.
   */
  CHIP = 'chip',
  /**
   * @deprecated variant_selector style will be removed in future version.
   * please use Variant selector component instead this prop.
   */
  VARIANT_SELECTOR = 'variant_selector',
}

enum PillType {
  SOLID = 'solid',
  OUTLINE = 'outline',
}
export { PillStyle, PillType };
